import clsx from 'clsx';
import { Fragment } from 'react';

import { JobDetailsType } from '@/features/strapi/types';

import styles from './AnchorNav.module.scss';

export const AnchorNav = ({
    content,
    activeId,
    setActive,
}: {
    content: JobDetailsType[];
    activeId: string;
    setActive?: (id: string) => void;
}) => {
    const scrollToSection = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });

            setActive && setActive(id);
        }
    };

    return (
        <nav className={styles.nav}>
            <ul>
                {content.map((detail) => (
                    <Fragment key={detail.id}>
                        {detail.anchor && (
                            <li
                                key={detail.id}
                                className={clsx({ [styles.active]: activeId === detail.anchor })}
                                data-testid={`nav-li-${detail.anchor}`}
                            >
                                <button
                                    className={styles.navLink}
                                    onClick={() => scrollToSection(detail.anchor)}
                                    data-testid={`nav-button-${detail.anchor}`}
                                >
                                    {detail.title}
                                </button>
                            </li>
                        )}
                    </Fragment>
                ))}
            </ul>
        </nav>
    );
};
